import { render } from "./CampaignHourlyImpressions.vue?vue&type=template&id=52240899&scoped=true"
import script from "./CampaignHourlyImpressions.vue?vue&type=script&lang=js"
export * from "./CampaignHourlyImpressions.vue?vue&type=script&lang=js"

import "./CampaignHourlyImpressions.vue?vue&type=style&index=0&id=52240899&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52240899"]])

export default __exports__